import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { BAND_PATHS } from "Bands/router";
import { clearActionMeta, dataMetaSelector } from "Bands/state";
import { BAND_ACTIONS } from "Bands/types";
import { useClearActionMetaOnUnMount, useEventRoute } from "Bands/utils";
import { IAPIState } from "shared/types";
import { useEventContext } from "Bands/contexts";
import { EditInfoBlock } from "Bands/containers";
import { mapUserPermissions } from "shared/utils";
import { FourOhThree } from "shared/pages";

export const CreateEventInfoBlockPage = () => {
  const { blockTypeId } = useParams<{ blockTypeId: string }>();

  const dispatch = useDispatch();
  const { api: createApiMeta, id: blockId } = useSelector(
    dataMetaSelector(BAND_ACTIONS.createEventInfoBlock)
  );

  const { pushRoute } = useEventRoute();
  const { eventId, event } = useEventContext();

  const currentInfoBlockType = useMemo(
    () => event?.eventInfoBlockTypes?.find(({ id }) => id === blockTypeId),
    [blockTypeId, event?.eventInfoBlockTypes]
  );

  useClearActionMetaOnUnMount(BAND_ACTIONS.createEventInfoBlock);

  useEffect(() => {
    if (!blockId || !eventId) return;

    if (createApiMeta?.status === IAPIState.succeeded) {
      dispatch(clearActionMeta(BAND_ACTIONS.createEventInfoBlock));

      pushRoute(BAND_PATHS.EDIT_INFO_BLOCK, {
        params: { blockId, blockTypeId },
      });
    }
  }, [dispatch, createApiMeta, blockId, eventId, pushRoute, blockTypeId]);

  if (!currentInfoBlockType) return null;

  if (!mapUserPermissions(currentInfoBlockType.permissions || []).CREATE_BLOCK) {
    return <FourOhThree />;
  }

  return <EditInfoBlock infoBlockType={currentInfoBlockType} />;
};
